export default function PHP_opendir() {
  return (
    <div>
      <h1>PHP_opendir</h1>
    </div>
  );
}
